import React from "react";

/**
 * I manage a periodic task, invoking it immediately, and then every `interval`
 * milliseconds afterward, as long as the component is mounted. The deps array
 * is the same as for React.useEffect: the variables the task closes over. If
 * the dependencies change, the task will be immediately invoked and
 * rescheduled, regardless of when the prior
 * invocation was.
 * @param task The task to periodically invoke
 * @param interval Interval in milliseconds between invocations
 * @param deps The dependencies of the task. If these change, the task will be
 *  immediately invoked with the new dependencies and the scheduler restarted.
 */
function usePeriodicTask(task, interval, deps) {
    React.useEffect(
        () => {
            task();
            // eslint-disable-next-line no-settimeout
            const id = setInterval(task, interval);
            return () => clearInterval(id);
        },
        deps,
    );
}

export default usePeriodicTask;



// WEBPACK FOOTER //
// ./app/lib/usePeriodicTask.js